// extracted by mini-css-extract-plugin
export default {"create":"Create_create__fRzQn","create-button":"Create_create-button__h32jS"};